import React from "react";

const BookmarkButton = ({ saved, pending, name, onToggle, className = "" }) => (
  <button
    type="button"
    className={`sy-bookmark${saved ? " is-saved" : ""} ${className}`}
    disabled={pending}
    aria-pressed={saved}
    aria-label={saved ? `Remove ${name} from saved` : `Save ${name}`}
    onClick={onToggle}
  >
    <svg viewBox="0 0 20 20" aria-hidden="true">
      <path d="M5 2.5h10a1 1 0 0 1 1 1v14l-6-3.6-6 3.6v-14a1 1 0 0 1 1-1Z" />
    </svg>
  </button>
);

export default BookmarkButton;
